import { useMutation, gql } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { getMappedErrors } from '../../../../packages/kiti/components/form/_helpers/mappedErros'

const ALERT_ENTITIES = ['Place', 'Contract']

const useDisableRequest = ({ client, entity, value, record, callback }) => {
  const notify = useNotification()

  const MUTATION = gql`
    mutation Upsert${entity} ($id: Int, $value: Boolean) {
			upsert${entity} (input: { id: $id, enabled: $value }) {
				id
        enabled
			}
    }
  `

  const [request, state] = useMutation(MUTATION, { client, onQueryUpdated: () => false })

  const isEnabled = !value
  const modal = useAlert()

  const handleRequest = () => {
    const alertTitle = 'Ao desativar esse registro, o mesmo poderá ser considerado na sua fatura!'
    if (!isEnabled && ALERT_ENTITIES.some(item => item === entity) && !modal.confirm({ title: alertTitle })) {
      return callback(!isEnabled)
    }

    return request({ variables: { id: record.id, value: isEnabled } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: `${isEnabled ? 'Ativado' : 'Desativado'} com sucesso!` })
        return
      }

      const mappedError = resp.errors.find(error => {
        const { message } = error
        const mappedResult = getMappedErrors(message)
        return mappedResult !== message
      })

      if (mappedError) {
        notify.error({ title: getMappedErrors(mappedError.message) })
      } else {
        notify.error({ title: `Ocorreu um erro ao ${isEnabled ? 'ativar' : 'desativar'}!` })
      }

      callback(!isEnabled)
    })
  }

  return [handleRequest, state]
}

export default useDisableRequest
